require('./mortgagesRequestConditionsView.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @ components
const { MortgageRequestConditions } = require('components/mortgageRequest/mortgageRequestConditions/mortgageRequestConditions');

class MortgageRequestConditionsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const breadCrumbData = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestConditions-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        const mortgateRequestClassName = contactCenterClassName('mortgage-request-conditions-view__body', 'grid-view__body')

        return (
            <div className="mortgage-request-conditions-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadCrumbData}
                                finalTitle={getFinalTitle('mortgageRequestConditions-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className={mortgateRequestClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <MortgageRequestConditions isClientWithoutAccounts={isClientWithoutAccounts} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestConditionsView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired
}

module.exports.MortgageRequestConditionsView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestConditionsView);
